import {
  Area,
  AreaChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { BetaChartCard } from 'src/pages/reports/components/beta-charts';
import { BetaChartAreaSkeleton } from 'src/pages/reports/components/beta-charts/beta-chart-skeletons';
import { BetaChartTooltip } from 'src/pages/reports/components/beta-charts/beta-chart-tooltip';
import { formatCompactNumber } from './overview-beta-format';

interface ConversionsTrendPoint {
  date: string;
  dateLabel: string;
  conversions: number;
}

interface OverviewBetaConversionsTrendProps {
  data: ConversionsTrendPoint[];
  isLoading?: boolean;
}

export function OverviewBetaConversionsTrend({
  data,
  isLoading = false,
}: OverviewBetaConversionsTrendProps) {
  return (
    <BetaChartCard
      title="Daily Conversions"
      subtitle="Trend across the selected period"
      className="mb-0"
    >
      {isLoading ? (
        <BetaChartAreaSkeleton className="h-[220px]" />
      ) : data.length === 0 ? (
        <div className="flex h-[220px] items-center justify-center text-sm text-[#8A8EA0]">
          No conversion trend for the selected period.
        </div>
      ) : (
        <div className="h-[220px] w-full">
          <ResponsiveContainer
            width="100%"
            height="100%"
          >
            <AreaChart
              data={data}
              margin={{ top: 8, right: 8, left: 0, bottom: 0 }}
            >
              <defs>
                <linearGradient
                  id="overviewConvFill"
                  x1="0"
                  y1="0"
                  x2="0"
                  y2="1"
                >
                  <stop
                    offset="0%"
                    stopColor="#2563EB"
                    stopOpacity={0.28}
                  />
                  <stop
                    offset="100%"
                    stopColor="#2563EB"
                    stopOpacity={0.02}
                  />
                </linearGradient>
              </defs>
              <CartesianGrid
                stroke="#EDEEF2"
                vertical={false}
              />
              <XAxis
                dataKey="dateLabel"
                tick={{ fill: '#8A8EA0', fontSize: 11 }}
                tickLine={false}
                axisLine={false}
              />
              <YAxis
                tick={{ fill: '#8A8EA0', fontSize: 11 }}
                tickLine={false}
                axisLine={false}
                width={40}
                tickFormatter={(value) => formatCompactNumber(Number(value))}
              />
              <Tooltip
                content={<BetaChartTooltip />}
                cursor={{ stroke: '#D9DBE3', strokeWidth: 1 }}
              />
              <Area
                type="monotone"
                dataKey="conversions"
                name="Conversions"
                stroke="#2563EB"
                fill="url(#overviewConvFill)"
                strokeWidth={2}
                dot={false}
                isAnimationActive={false}
              />
            </AreaChart>
          </ResponsiveContainer>
        </div>
      )}
    </BetaChartCard>
  );
}
